import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor() {
        this.e13_1 = this;
        this.f13_1 = this;
        this.g13_1 = false;
      }
      h13(node, permissionsBitmask) {
        var prev = this.f13_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.l1m_1 & permissionsBitmask) === 0 && prev.h13(node, permissionsBitmask));
        } else {
          node.e13_1 = this;
          node.f13_1 = prev;
          prev.e13_1 = node;
          this.f13_1 = node;
          tmp = true;
        }
        return tmp;
      }
      w15(forbiddenElementsBit) {
        this.h13(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      i13() {
        if (this.g13_1)
          return false;
        var prev = this.f13_1;
        var next = this.e13_1;
        prev.e13_1 = next;
        next.f13_1 = prev;
        this.g13_1 = true;
        return true;
      }
      j13(node) {
        if (!(this.e13_1 === this))
          return false;
        this.h13(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.l1m_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
